import {
  FileOutlined
} from "@ant-design/icons";
import {
  Badge,
  Button,
  FloatButton,
  Progress,
  Space,
  Typography
} from "antd";
import axios from "axios";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "../../styles/ClientProfileStyle.css";
import CheckAuth from "../authentication/common/hooks/CheckAuth";
import ProfileLoaderLayout from "../screenLoader/ProfileLoaderLayout";
var CryptoJS = require("crypto-js");
const Utility = require("../../utils/Utility");

export default function ClientProfileLayout() {
  const [loading, setLoading] = useState(true);
  const base_url = process.env.REACT_APP_BASE_URL;
  const secret_key = process.env.REACT_APP_MY_SECRET_KEY;

  const [
    profileCompletionPercentage,
    setProfileCompletionPercentage,
  ] = useState("");
  const [employeeUserId, setEmployeeUserId] = useState("");
  const [employeeID, setEmployeeID] = useState("");
  const [employeeName, setEmployeename] = useState("");
  const [employeeEmail, setEmployeeEmail] = useState("");
  const [employeeImage, setEmployeeImage] = useState("");
  const [employeeReligion, setEmployeeReligion] = useState("");
  const [employeeContact, setEmployeeContact] = useState("");
  const [employeeType, setEmployeeType] = useState("");
  const [employeeDesignation, setEmployeeDesignation] = useState("");
  const [emplyeeDepartment, setEmployeeDepartment] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [employeeJoiningDate, setEmployeeJoiningDate] = useState("");
  const [employeeNIDName, setEmployeeNIDName] = useState("");
  const [employeeNIDNumber, setEmployeeNIDNumber] = useState("");
  const [employeeBankAccountNumber, setEmployeeBankAccountNumber] =
    useState("");
  const [employeeBankAccountName, setEmployeeBankAccountName] = useState("");
  const [employeeETIN, setEmployeeETIN] = useState("");
  const [employeeETINName, setEmployeeETINName] = useState("");
  const [employeePresentAddress, setEmployeePresentAddress] = useState("");
  const [employeePermanentAddress, setEmployeePermanentAddress] = useState("");
  const [employeeEmergencyContactOne, setEmployeeEmergencyContactOne] =
    useState("");
  const [employeeEmergencyContactTwo, setEmployeeEmergencyContactTwo] =
    useState("");

  const [employeeImageError, setEmployeeImageError] = useState(false);

  //for file system operations

  //for file system operations
  const [nidDoc, setNIDDoc] = useState(null);
  const [fileListForNIDDoc, setFileListForNIDDoc] = useState([]);
  const [passportDoc, setPassportDoc] = useState(null);
  const [fileListForPassPortDoc, setFileListForPassportDoc] = useState([]);
  const [tinDoc, setTinDoc] = useState(null);
  const [fileListForTinDoc, setFileListForTinDoc] = useState([]);
  const [taxReturnDoc, setTaxReturnDoc] = useState(null);
  const [fileListForTaxReturnDoc, setFileListForTaxReturnDoc] = useState(null);
  const [sscDoc, setSSCDoc] = useState(null);
  const [fileListForSSCDoc, setFileListForSSCDoc] = useState(null);
  const [hscDoc, setHSCDoc] = useState(null);
  const [fileListForHSCDoc, setFileListForHSCDoc] = useState(null);
  const [honsDoc, setHonsDoc] = useState(null);
  const [fileListForHonsDoc, setFileListForHonsDoc] = useState(null);
  const [lastOfficeClearanceDoc, setLastOfficeClearanceDoc] = useState(null);
  const [
    fileListForLastOfficeClearanceDoc,
    setFileListForLastOfficeClearanceDoc,
  ] = useState(null);
  const [officeSalaryCertificateDoc, setOfficeSalaryCertificaeDoc] =
    useState(null);
  const [
    fileListForOfficeSalaryCertificateDoc,
    setFileListForOfficeSalaryCertificateDoc,
  ] = useState(null);

  let utility = new Utility();

  const notUpdatedText = "Not Updated Yet";

  CheckAuth();

  const user_id = sessionStorage.getItem("userData");

  useEffect(() => {
    const fetchData = debounce(async () => {
      try {
        setLoading(true);
        const accessToken = sessionStorage.getItem("accessToken");
        const user_id = sessionStorage.getItem("userData");

        const response = await axios.get(
          `${base_url}/api/v1/client/client-profile/${user_id}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );

        const { data } = response;
        let profile = data.data.userProfileData;
        setEmployeeUserId(profile.user_id);
        setEmployeeImage(profile.passport_size_photo);
        setEmployeeID(profile.employee_id);
        setEmployeeEmail(profile.email);
        setProfileCompletionPercentage(data.profileCompletionProgressPercentage);
        setEmployeeNIDName(profile.name_in_nid);
        setEmployeeDesignation(profile.designation);
        setEmployeeDepartment(profile.department);
        setEmployeeType(profile.type);
        setEmployeeJoiningDate(profile.joining_date);
        setEmployeeContact(profile.contact);
        setBloodGroup(profile.blood_group);
        setEmployeeNIDNumber(utility.decryptData(profile.nid_number));
        setEmployeeBankAccountNumber(utility.decryptData(profile.bank_account_name));
        setEmployeeBankAccountName(utility.decryptData(profile.bank_account_number));
        setEmployeeETIN(utility.decryptData(profile.etin));
        setEmployeeETINName(utility.decryptData(profile.name_in_etin));
        setEmployeePresentAddress(utility.decryptData(profile.present_address));
        setEmployeePermanentAddress(utility.decryptData(profile.permanent_address));
        setEmployeeEmergencyContactOne(data.dataForEmergencyContacts.emergency_contact_one);
        setEmployeeEmergencyContactTwo(data.dataForEmergencyContacts.emergency_contact_two);


        /*setEmployeeID(data.data.userProfileData.employee_id);
        setEmployeename(data.data.userProfileData.name);
        setEmployeeEmail(data.data.userProfileData.email);
        setEmployeeImage(data.data.userProfileData.passport_size_photo);
        setEmployeeUserId(data.data.userProfileData.user_id);
        setEmployeeReligion(data.data.userProfileData.religion);

        setBloodGroup(data.data.userProfileData.blood_group);
        setEmployeeContact(data.data.userProfileData.contact);
        setEmployeeJoiningDate(data.data.userProfileData.joining_date);
        setEmployeeNIDNumber(decryptedNIDNUmber);
        setEmployeeBankAccountNumber(decryptedBankAccountNumber);
        setEmployeeBankAccountName(decryptedBankAccountName);
        setEmployeeETIN(decryptedeTIN);
        setEmployeeETINName(decryptedNameIneTIN);
        setEmployeePresentAddress(decryptedPresentAddress);
        setEmployeePermanentAddress(decryptedPermanentAddress);
        setEmployeeType(data.data.userProfileData.type);*/

        //fetching files
        setNIDDoc(response.data.data.userProfileData.nid);
        setPassportDoc(response.data.data.userProfileData.passport);
        setTinDoc(response.data.data.userProfileData.tin);
        setSSCDoc(response.data.data.userProfileData.ssc_certificate);
        setHSCDoc(response.data.data.userProfileData.hsc_certificate);
        setHonsDoc(response.data.data.userProfileData.hons_certificate);
        setTaxReturnDoc(
          response.data.data.userProfileData.tax_return_documents
        );
        setLastOfficeClearanceDoc(
          response.data.data.userProfileData.last_office_clearance
        );
        setOfficeSalaryCertificaeDoc(
          response.data.data.userProfileData.last_office_salary_certificate
        );
        if (nidDoc) {
          const updatedFileList = [
            {
              status: "done",
              url: `${base_url}/client/${user_id}/${nidDoc}`,
            },
          ];
          setFileListForNIDDoc(updatedFileList);
        }
        if (tinDoc) {
          const updatedFileList = [
            {
              status: "done",
              url: `${base_url}/client/${user_id}/${tinDoc}`,
            },
          ];
          setFileListForTinDoc(updatedFileList);
        }
        if (passportDoc) {
          const updatedFileList = [
            {
              status: "done",
              url: `${base_url}/client/${user_id}/${passportDoc}`,
            },
          ];
          setFileListForPassportDoc(updatedFileList);
        }
        if (taxReturnDoc) {
          const updatedFileList = [
            {
              status: "done",
              url: `${base_url}/client/${user_id}/${taxReturnDoc}`,
            },
          ];
          setFileListForTaxReturnDoc(updatedFileList);
        }
        if (lastOfficeClearanceDoc) {
          const updatedFileList = [
            {
              status: "done",
              url: `${base_url}/client/${user_id}/${lastOfficeClearanceDoc}`,
            },
          ];
          setFileListForLastOfficeClearanceDoc(updatedFileList);
        }
        if (officeSalaryCertificateDoc) {
          const updatedFileList = [
            {
              status: "done",
              url: `${base_url}/client/${user_id}/${officeSalaryCertificateDoc}`,
            },
          ];
          setFileListForOfficeSalaryCertificateDoc(updatedFileList);
        }
        if (sscDoc) {
          const updatedFileList = [
            {
              status: "done",
              url: `${base_url}/client/${user_id}/${sscDoc}`,
            },
          ];
          setFileListForSSCDoc(updatedFileList);
        }
        if (hscDoc) {
          const updatedFileList = [
            {
              status: "done",
              url: `${base_url}/client/${user_id}/${hscDoc}`,
            },
          ];
          setFileListForHSCDoc(updatedFileList);
        }
        if (honsDoc) {
          const updatedFileList = [
            {
              status: "done",
              url: `${base_url}/client/${user_id}/${honsDoc}`,
            },
          ];
          setFileListForHonsDoc(updatedFileList);
        }

        // console.log(data.data)
        setTimeout(() => {
          setLoading(false);
        }, 500);
      } catch (error) {
        // Handle error state or display an error message
        setLoading(false);
      }
    }, 200);

    const debouncedFetchData = debounce(fetchData, 200); // Adjust the debounce delay as needed
    debouncedFetchData();
    return () => {
      // Cancel the debounced function when the component unmounts
      debouncedFetchData.cancel();
    };
  }, []);

  //for opening files
  const openFileInNewTab = (docType) => {
    if (docType === "nidDoc" && nidDoc) {
      window.open(`${base_url}/client/${user_id}/${nidDoc}`, "_blank");
    }
    if (docType === "tinDoc" && tinDoc) {
      window.open(`${base_url}/client/${user_id}/${tinDoc}`, "_blank");
    }
    if (docType === "taxReturnDoc" && taxReturnDoc) {
      window.open(`${base_url}/client/${user_id}/${taxReturnDoc}`, "_blank");
    }
    if (docType === "passportDoc" && passportDoc) {
      window.open(`${base_url}/client/${user_id}/${passportDoc}`, "_blank");
    }
    if (docType === "lastOfficeClearanceDoc" && lastOfficeClearanceDoc) {
      window.open(
        `${base_url}/client/${user_id}/${lastOfficeClearanceDoc}`,
        "_blank"
      );
    }
    if (
      docType === "officeSalaryCertificateDoc" &&
      officeSalaryCertificateDoc
    ) {
      window.open(
        `${base_url}/client/${user_id}/${officeSalaryCertificateDoc}`,
        "_blank"
      );
    }
    if (docType === "sscDoc" && sscDoc) {
      window.open(`${base_url}/client/${user_id}/${sscDoc}`, "_blank");
    }
    if (docType === "hscDoc" && hscDoc) {
      window.open(`${base_url}/client/${user_id}/${hscDoc}`, "_blank");
    }
    if (docType === "honsDoc" && honsDoc) {
      window.open(`${base_url}/client/${user_id}/${honsDoc}`, "_blank");
    }
  };

  const handleImageError = () => {
   
    setEmployeeImageError(true);
  };

  return (
    <>
      {loading ? (
        <div className="overlay client-profile">
          <ProfileLoaderLayout screenLoaderText="Loading Profile..." />
        </div>
      ) : (
        <div
          className="container client-profile"
        >
          <div className="main-body" style={{ justifyContent: "center" }}>
            <div className="row" style={{ justifyContent: "center" }}>
              <div className="col-lg-8 basic-profil-info">
                <div
                  className="card"
                  style={{
                    border: "0 solid transparent",
                    borderRadius: "0.25rem",
                    marginBottom: "1.5rem",
                    boxShadow:
                      "0 2px 6px 0 rgb(218, 218, 253, 65%), 0 2px 6px 0 rgb(206, 206, 238, 54%)",
                  }}
                >
                  <div className="card-body">
                    <div className="d-flex flex-column ">
                      <div className="profile-block">
                        {employeeImageError || employeeImage === null ? (
                          <img
                            src={`${base_url}/client/default/clientProfileImage.png`}
                            style={{
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                            }}
                            alt="EmployeeImage"
                            className="rounded-circle p-1"
                            width="120"
                            onError={handleImageError} 
                          />
                        ) : (
                          <img
                            src={
                              `${base_url}/client/${employeeUserId}/` +
                              employeeImage
                            }
                            style={{
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                            }}
                            alt="EmployeeImage"
                            className="rounded-circle p-1"
                            width="120"
                            onError={handleImageError}
                          />
                        )}
                        <div>
                          <NavLink
                            to="/profile-completion"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              textDecoration: "none",
                            }}
                          >
                            <Button
                              type="primary"
                              style={{
                                backgroundColor: "rgb(0,176,240)",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                              }}
                            >
                              <i className="fas fa-edit"></i>&nbsp; Update Profile
                            </Button>
                          </NavLink>
                        </div>
                      </div>

                      <div className="mt-3 ml-3">
                        <div>
                          <h4>{employeeName}</h4>
                          <p className="text-secondary mb-1">
                            Employee ID : {employeeID}
                          </p>
                          <p className="text-muted font-size-sm">
                            {" "}
                            Email : {employeeEmail}{" "}
                          </p>
                          {<p className="text-muted font-size-sm">
                            {" "}
                            <Badge
                                size="large"
                                status="processing"
                                text="Progress"
                            />
                            <Progress
                                percent={parseInt(profileCompletionPercentage)}
                                status="active"
                                strokeColor={{
                                  from: "#87CEFA",
                                  to: "#1E90FF",
                                }}
                                // style={{ marginBottom: "30px", marginTop: "20px" }}
                            />
                          </p>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="client-profile-card">
                  <div className="card-body " style={{ padding: "12px" }}>
                    <h5 className="d-flex align-items-center mb-3 ">
                      General Information
                    </h5>
                    {employeeNIDName ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3 info-row-label">
                          <h6 className="mb-0">NID Name </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={employeeNIDName}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3 info-row-label">
                          <h6 className="mb-0">NID Name *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {employeeDesignation ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3 info-row-label">
                          <h6 className="mb-0">Designation </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={employeeDesignation}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3 info-row-label">
                          <h6 className="mb-0">Designation *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {emplyeeDepartment ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3 info-row-label">
                          <h6 className="mb-0">Department </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={emplyeeDepartment}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Department *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {employeeType ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Type </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={employeeType}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Type *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}

                    {employeeJoiningDate ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Joining Date </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={employeeJoiningDate}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Joining Date *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {employeeContact ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Contact </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={employeeContact}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Contact *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {bloodGroup ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Blood Group </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={bloodGroup}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Blood Group *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="client-profile-card">
                  <div className="card-body" style={{ padding: "12px" }}>
                    <h5 className="d-flex align-items-center mb-3">
                      Confidential Information
                    </h5>
                    {employeeNIDNumber ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">NID Number </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={employeeNIDNumber}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">NID Number *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {employeeBankAccountName ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Bank Account Name </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={employeeBankAccountName}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Bank Account Name *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {employeeBankAccountNumber ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Bank Account Number </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={employeeBankAccountNumber}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Bank Account Number *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {employeeETIN ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">ETIN </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={employeeETIN}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">ETIN *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {employeeETINName ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">ETIN Name </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={employeeETINName}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">ETIN Name *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}

                    {employeePresentAddress ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Present Address </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={employeePresentAddress}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Present Address*</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {employeePermanentAddress ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Permanent Address</h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={employeePermanentAddress}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Permanent Address *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="client-profile-card">
                  <div className="card-body" style={{ padding: "12px" }}>
                    <h5 className="d-flex align-items-center mb-3">
                      Emergency Contact{" "}
                    </h5>
                    {employeeEmergencyContactOne ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Contact One </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={utility.decryptData(employeeEmergencyContactOne)}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Contact One *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {employeeEmergencyContactTwo ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Contact Two </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={utility.decryptData(employeeEmergencyContactTwo)}
                            disabled
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Contact Two *</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="client-profile-card">
                  <div className="card-body" style={{ padding: "12px" }}>
                    <h5 className="d-flex align-items-center mb-3">
                      Scanned Documents
                    </h5>
                    {nidDoc ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">NID Doc</h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          {nidDoc && (
                            <Space
                              direction="vertical"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "rgb(0,0,0,0.05)",
                                padding: "6px",
                                margin: "5px",
                                borderRadius: "10px",
                                boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#D1E7FA";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "rgb(0,0,0,0.02)";
                              }}
                            >
                              <Space>
                                <FileOutlined />
                                <Typography
                                  style={{ fontSize: "12px" }}
                                  onClick={() => openFileInNewTab("nidDoc")}
                                >
                                  {" "}
                                  Open Uploaded Document
                                </Typography>
                              </Space>
                            </Space>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">NID Doc*</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {passportDoc ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Passport Doc </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          {passportDoc && (
                            <Space
                              direction="vertical"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "rgb(0,0,0,0.05)",
                                padding: "6px",
                                margin: "5px",
                                borderRadius: "10px",
                                boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#D1E7FA";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "rgb(0,0,0,0.05)";
                              }}
                            >
                              <Space>
                                <FileOutlined />
                                <Typography
                                  style={{ fontSize: "12px" }}
                                  onClick={() =>
                                    openFileInNewTab("passportDoc")
                                  }
                                >
                                  {" "}
                                  Open Uploaded Document
                                </Typography>
                              </Space>
                            </Space>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Passport Doc*</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {/* //new */}
                    {tinDoc ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">TIN Doc </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          {tinDoc && (
                            <Space
                              direction="vertical"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "rgb(0,0,0,0.05)",
                                padding: "6px",
                                margin: "5px",
                                borderRadius: "10px",
                                boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#D1E7FA";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "rgb(0,0,0,0.05)";
                              }}
                            >
                              <Space>
                                <FileOutlined />
                                <Typography
                                  style={{ fontSize: "12px" }}
                                  onClick={() => openFileInNewTab("tinDoc")}
                                >
                                  {" "}
                                  Open Uploaded Document
                                </Typography>
                              </Space>
                            </Space>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">TIN Doc*</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {taxReturnDoc ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Tax Return Doc </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          {taxReturnDoc && (
                            <Space
                              direction="vertical"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "rgb(0,0,0,0.05)",
                                padding: "6px",
                                margin: "5px",
                                borderRadius: "10px",
                                boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#D1E7FA";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "rgb(0,0,0,0.05)";
                              }}
                            >
                              <Space>
                                <FileOutlined />
                                <Typography
                                  style={{ fontSize: "12px" }}
                                  onClick={() =>
                                    openFileInNewTab("taxReturnDoc")
                                  }
                                >
                                  {" "}
                                  Open Uploaded Document
                                </Typography>
                              </Space>
                            </Space>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Tax Return Doc*</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {lastOfficeClearanceDoc ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Last Office Clearance Doc </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          {lastOfficeClearanceDoc && (
                            <Space
                              direction="vertical"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "rgb(0,0,0,0.05)",
                                padding: "6px",
                                margin: "5px",
                                borderRadius: "10px",
                                boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#D1E7FA";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "rgb(0,0,0,0.05)";
                              }}
                            >
                              <Space>
                                <FileOutlined />
                                <Typography
                                  style={{ fontSize: "12px" }}
                                  onClick={() =>
                                    openFileInNewTab("lastOfficeClearanceDoc")
                                  }
                                >
                                  {" "}
                                  Open Uploaded Document
                                </Typography>
                              </Space>
                            </Space>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Last Office Clearance Doc*</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {officeSalaryCertificateDoc ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">
                            Office Salary Certificate Doc{" "}
                          </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          {officeSalaryCertificateDoc && (
                            <Space
                              direction="vertical"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "rgb(0,0,0,0.05)",
                                padding: "6px",
                                margin: "5px",
                                borderRadius: "10px",
                                boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#D1E7FA";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "rgb(0,0,0,0.05)";
                              }}
                            >
                              <Space>
                                <FileOutlined />
                                <Typography
                                  style={{ fontSize: "12px" }}
                                  onClick={() =>
                                    openFileInNewTab(
                                      "officeSalaryCertificateDoc"
                                    )
                                  }
                                >
                                  {" "}
                                  Open Uploaded Document
                                </Typography>
                              </Space>
                            </Space>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">
                            Office Salary Certificate Doc*
                          </h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {sscDoc ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">SSC Doc </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          {sscDoc && (
                            <Space
                              direction="vertical"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "rgb(0,0,0,0.05)",
                                padding: "6px",
                                margin: "5px",
                                borderRadius: "10px",
                                boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#D1E7FA";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "rgb(0,0,0,0.05)";
                              }}
                            >
                              <Space>
                                <FileOutlined />
                                <Typography
                                  style={{ fontSize: "12px" }}
                                  onClick={() => openFileInNewTab("sscDoc")}
                                >
                                  {" "}
                                  Open Uploaded Document
                                </Typography>
                              </Space>
                            </Space>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">SSC Doc*</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {hscDoc ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">HSC Doc </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          {hscDoc && (
                            <Space
                              direction="vertical"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "rgb(0,0,0,0.05)",
                                padding: "6px",
                                margin: "5px",
                                borderRadius: "10px",
                                boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#D1E7FA";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "rgb(0,0,0,0.05)";
                              }}
                            >
                              <Space>
                                <FileOutlined />
                                <Typography
                                  style={{ fontSize: "12px" }}
                                  onClick={() => openFileInNewTab("hscDoc")}
                                >
                                  {" "}
                                  Open Uploaded Document
                                </Typography>
                              </Space>
                            </Space>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">HSC Doc*</h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                    {honsDoc ? (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">
                            {" "}
                            Hons Certificate (BSc/BA/BBA...){" "}
                          </h6>
                        </div>

                        <div className="col-sm-9 text-secondary mt-1">
                          {honsDoc && (
                            <Space
                              direction="vertical"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "rgb(0,0,0,0.05)",
                                padding: "6px",
                                margin: "5px",
                                borderRadius: "10px",
                                boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#D1E7FA";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "rgb(0,0,0,0.05)";
                              }}
                            >
                              <Space>
                                <FileOutlined />
                                <Typography
                                  style={{ fontSize: "12px" }}
                                  onClick={() => openFileInNewTab("honsDoc")}
                                >
                                  {" "}
                                  Open Uploaded Document
                                </Typography>
                              </Space>
                            </Space>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="row mb-3 text-muted">
                        <div className="col-sm-3">
                          <h6 className="mb-0">
                            Hons Certificate (BSc/BA/BBA...)*
                          </h6>
                        </div>
                        <div className="col-sm-9 text-secondary mt-1">
                          <input
                            type="text"
                            className="form-control"
                            value={notUpdatedText}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <FloatButton.BackTop tooltip="Move Up" />
    </>
  );
}
